// Registres plateforme (SUPER_ADMIN) — stockés via /platform/registry/:key
export const PLATFORM_REGISTRIES = {
  support: {
    key: 'support', title: 'Support technique',
    labelField: 'subject', columns: ['subject', 'school', 'priority', 'status'],
    fields: [
      { key: 'subject', label: 'Sujet', type: 'text', required: true },
      { key: 'school', label: 'École concernée', type: 'text' },
      { key: 'category', label: 'Catégorie', type: 'select', options: ['Bug', 'Assistance', 'Demande', 'Incident', 'Facturation'] },
      { key: 'priority', label: 'Priorité', type: 'select', options: ['Basse', 'Normale', 'Haute', 'Urgente'] },
      { key: 'status', label: 'Statut', type: 'select', options: ['Ouvert', 'En cours', 'Résolu', 'Fermé'] },
      { key: 'assignedTo', label: 'Assigné à', type: 'text' },
      { key: 'openedDate', label: 'Ouvert le', type: 'date' },
      { key: 'description', label: 'Description', type: 'textarea' },
    ],
  },
  monitoring: {
    key: 'monitoring', title: 'Supervision technique',
    labelField: 'service', columns: ['service', 'status', 'value', 'checkedAt'],
    fields: [
      { key: 'service', label: 'Service', type: 'select', required: true, options: ['API', 'Base de données', 'Frontend', 'Passerelle SMS', 'Stockage', 'Sauvegardes'] },
      { key: 'metric', label: 'Métrique', type: 'text' },
      { key: 'value', label: 'Valeur', type: 'text' },
      { key: 'status', label: 'État', type: 'select', options: ['OK', 'Dégradé', 'Incident'] },
      { key: 'checkedAt', label: 'Relevé le', type: 'date' },
      { key: 'notes', label: 'Notes', type: 'textarea' },
    ],
  },
  security: {
    key: 'security', title: 'Sécurité & conformité',
    labelField: 'event', columns: ['event', 'type', 'severity', 'date'],
    fields: [
      { key: 'event', label: 'Événement', type: 'text', required: true },
      { key: 'type', label: 'Type', type: 'select', options: ['Connexion', 'Incident', 'Audit', 'RGPD', 'Accès'] },
      { key: 'severity', label: 'Gravité', type: 'select', options: ['Info', 'Faible', 'Moyenne', 'Élevée', 'Critique'] },
      { key: 'source', label: 'Source', type: 'text' },
      { key: 'date', label: 'Date', type: 'date' },
      { key: 'action', label: 'Action menée', type: 'textarea' },
    ],
  },
  config: {
    key: 'config', title: 'Configuration plateforme',
    labelField: 'key', columns: ['key', 'category', 'value'],
    fields: [
      { key: 'key', label: 'Paramètre', type: 'text', required: true },
      { key: 'value', label: 'Valeur', type: 'text' },
      { key: 'category', label: 'Catégorie', type: 'select', options: ['Général', 'SMS', 'E-mail', 'Facturation', 'Limites', 'Sécurité'] },
      { key: 'description', label: 'Description', type: 'textarea' },
    ],
  },
  marketing: {
    key: 'marketing', title: 'Marketing & commercial',
    labelField: 'campaign', columns: ['campaign', 'channel', 'status', 'value'],
    fields: [
      { key: 'campaign', label: 'Campagne / Prospect', type: 'text', required: true },
      { key: 'channel', label: 'Canal', type: 'select', options: ['E-mail', 'SMS', 'Réseaux sociaux', 'Terrain', 'Référence'] },
      { key: 'status', label: 'Statut', type: 'select', options: ['Prospect', 'Contacté', 'Démo', 'Négociation', 'Gagné', 'Perdu'] },
      { key: 'contact', label: 'Contact', type: 'text' },
      { key: 'phone', label: 'Téléphone', type: 'text' },
      { key: 'value', label: 'Valeur estimée', type: 'money' },
      { key: 'notes', label: 'Notes', type: 'textarea' },
    ],
  },
  analytics: {
    key: 'analytics', title: 'Analytique produit',
    labelField: 'metric', columns: ['metric', 'module', 'period', 'value'],
    fields: [
      { key: 'metric', label: 'Indicateur', type: 'text', required: true },
      { key: 'module', label: 'Module', type: 'text' },
      { key: 'period', label: 'Période', type: 'text' },
      { key: 'value', label: 'Valeur', type: 'number' },
      { key: 'trend', label: 'Tendance', type: 'select', options: ['En hausse', 'Stable', 'En baisse'] },
      { key: 'notes', label: 'Notes', type: 'textarea' },
    ],
  },
  billing: {
    key: 'billing', title: 'Facturation Schoolizy',
    labelField: 'school', columns: ['school', 'invoiceNo', 'amount', 'status'],
    fields: [
      { key: 'school', label: 'École', type: 'text', required: true },
      { key: 'invoiceNo', label: 'N° de facture', type: 'text' },
      { key: 'period', label: 'Période', type: 'text' },
      { key: 'amount', label: 'Montant', type: 'money' },
      { key: 'status', label: 'Statut', type: 'select', options: ['Émise', 'Payée', 'En retard', 'Annulée'] },
      { key: 'dueDate', label: 'Échéance', type: 'date' },
      { key: 'paidDate', label: 'Payée le', type: 'date' },
      { key: 'notes', label: 'Notes', type: 'textarea' },
    ],
  },
};
